"use strict"; 

function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NavA11y =
/*#__PURE__*/
function () {
  function NavA11y(_ref) {
    var _this = this;

    var menuId = _ref.menuId,
        activeClass = _ref.activeClass;

    _classCallCheck(this, NavA11y);

    _defineProperty(this, "setupAriaAttributes", function () {
      _this.menuItems.forEach(function (menuItem, index) {
        var menuLink = menuItem.querySelector("a");
        var submenus = menuItem.querySelectorAll("ul");

        if (submenus.length > 0) {
          var itemId = "menua11y-item-" + index;
          var submenuId = "menua11y-menu-" + index;
          menuLink.setAttribute("aria-haspopup", true);
          menuLink.setAttribute("aria-expanded", false);
          menuLink.setAttribute("aria-controls", submenuId);
          submenus.forEach(function (submenu) {
            submenu.setAttribute("aria-expanded", false);
            submenu.setAttribute("role", "group"); // Set tabindex to -1 so submenu links cannot receive focus until menu is open

            var links = submenu.querySelectorAll("a");
            links.forEach(function (link) {
              link.setAttribute("tabindex", -1);
            });
          });
        }
      });
    });

    _defineProperty(this, "setupEventBindings", function () {
      // Close active submenus when user click outside the menu
      document.addEventListener("click", function (event) {
        if (!_this.menu.contains(event.target)) _this.closeAllMenus();
      });

      _this.menuLinks.forEach(function (link) {
        link.addEventListener("focus", function (event) {
          _this.topLevelItems.forEach(function (topLevelItem) {
            if (!topLevelItem.contains(document.activeElement)) {
              _this.closeSubmenu(topLevelItem);
            }
          });
        });
      });

      _this.menu.addEventListener("keydown", function (event) {
        var item = event.target.parentElement; // const link = event.target;

        var nextItem = _this.adjacentSiblingLink(item, "next");

        var prevItem = _this.adjacentSiblingLink(item, "prev");

        var nextLink = _this.adjacentTopLevelLink(event.target, "next");

        var prevLink = _this.adjacentTopLevelLink(event.target, "prev");

        var isTopLevelItem = _this.isTopLevel(item, event);

        var hasSubmenu = event.target.getAttribute("aria-haspopup") === "true";
        var isOpen = event.target.getAttribute("aria-expanded") === "true";

        var isSubSubmenuItem = _this.isDeepMenu(item, event);

        switch (event.key) {
          // case "Enter":
          case " ":
            // isOpen ? this.closeSubmenu(item) : this.openSubmenu(item)
            event.preventDefault();
            if (!isOpen) _this.openSubmenu(item);
            break;

          case "Escape":
            // event.target.blur();
            // Move focus to the closest top level item
            _this.moveFocusToTop(item);

            _this.closeAllMenus();

            break;

          case "ArrowRight":
            if (!isTopLevelItem && hasSubmenu) {
              _this.openSubmenu(item);
            } else if (nextLink) {
              if (isSubSubmenuItem) {
                _this.closeSubmenu(isSubSubmenuItem.parentNode);
              }

              nextLink.focus();
            }

            break;

          case "ArrowLeft":
            if (isSubSubmenuItem) {
              var list = item.parentNode.parentNode;

              _this.closeSubmenu(list);

              list.querySelector("a").focus();
            } else if (prevLink) {
              prevLink.focus();
            }

            break;

          case "ArrowDown":
            event.preventDefault();

            if (isTopLevelItem && hasSubmenu) {
              _this.openSubmenu(item);
            } else if (nextItem) {
              nextItem.focus();
            }

            break;

          case "ArrowUp":
            event.preventDefault();
            if (prevItem) prevItem.focus();
            break;

          default:
            // nada
            break;
        }
      });
    });

    _defineProperty(this, "moveFocusToTop", function (item, event) {
      var currentIndex = 0;

      _this.topLevelItems.forEach(function (topItem, index) {
        if (topItem.contains(item)) currentIndex = index;
      });

      _this.topLevelItems[currentIndex].querySelector("a").focus();
    });

    _defineProperty(this, "isTopLevel", function (item, event) {
      var response = false;

      _this.topLevelItems.forEach(function (topLevelItem) {
        if (topLevelItem === event.target.parentNode) {
          response = true;
        }
      });

      return response;
    });

    _defineProperty(this, "isDeepMenu", function (item, event) {
      var response = false;

      _this.subSubmenus.forEach(function (subSubmenu) {
        if (subSubmenu.contains(event.target)) response = subSubmenu;
      });

      return response;
    });

    _defineProperty(this, "openSubmenu", function (menuItem) {
      menuItem.classList.add(_this.activeClass);
      var submenu = menuItem.querySelector("ul");
      if (!submenu) return;
      var firstLink = submenu.querySelector("a");
      if (!submenu) return;

      _this.toggleAriaAttributes(menuItem, submenu, true);

      firstLink.focus();
    });

    _defineProperty(this, "closeSubmenu", function (menuItem) {
      menuItem.classList.remove(_this.activeClass);
      var submenu = menuItem.querySelector("ul");
      if (!submenu) return;

      _this.toggleAriaAttributes(menuItem, submenu, false);
    });

    _defineProperty(this, "toggleAriaAttributes", function (menuItem, submenu) {
      var expanded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var childLinks = _this.getChildLinks(menuItem, submenu);

      var menuLink = menuItem.querySelector("a");
      menuLink.setAttribute("aria-expanded", expanded);
      submenu.setAttribute("aria-expanded", expanded);
      childLinks.forEach(function (childLink) {
        childLink.setAttribute("tabindex", expanded ? 0 : -1);
      });
    });

    _defineProperty(this, "getChildLinks", function (menuItem, submenu) {
      var childLinks = [];
      var submenuLinks = menuItem.querySelectorAll("a"); // Find the next level submenu links, ignore sub-submenu (next level down) links.

      submenuLinks.forEach(function (submenuLink) {
        var parent = submenuLink.parentNode;

        if (parent.parentNode === submenu) {
          childLinks.push(submenuLink);
        }
      });
      return childLinks;
    });

    _defineProperty(this, "closeAllMenus", function () {
      _this.menuLinks.forEach(function (menuLink) {
        if (menuLink.getAttribute("aria-expanded") === "true") _this.closeSubmenu(menuLink.parentNode);
      });
    });

    this.activeClass = activeClass || "active";
    this.menu = document.getElementById(menuId);
    this.menuItems = this.menu.querySelectorAll("li");
    this.menuLinks = this.menu.querySelectorAll("a");
    this.topLevelItems = document.querySelectorAll("#".concat(menuId, " > li"));
    this.subSubmenus = this.menu.querySelectorAll("li li ul");
    this.setupAriaAttributes();
    this.setupEventBindings();
  }

  _createClass(NavA11y, [{
    key: "adjacentTopLevelLink",
    value: function adjacentTopLevelLink(item, direction) {
      var topLevelItemsCount = this.topLevelItems.length;
      var directionIndex = direction === "next" ? 1 : -1;
      var nextIndex;
      this.topLevelItems.forEach(function (topItem, index) {
        if (topItem.contains(item)) nextIndex = index + directionIndex;
      });

      if (nextIndex < 0) {
        nextIndex = topLevelItemsCount - 1;
      } else if (nextIndex >= topLevelItemsCount) {
        nextIndex = 0;
      }
	
      return topLevelItemsCount > 1 ? this.topLevelItems[nextIndex].querySelector("a") : this.topLevelItems[0];
    }
  }, {
    key: "adjacentSiblingLink",
    value: function adjacentSiblingLink(item, direction) {
      var link = item.querySelector("a");
      var siblings = item.parentElement.querySelectorAll("a[tabindex='0']");
      var directionIndex = direction === "next" ? 1 : -1;
      var nextIndex;
      siblings.forEach(function (sibling, index) {
        if (sibling === link) nextIndex = index + directionIndex;
      });

      if (nextIndex < 0) {
        nextIndex = siblings.length - 1;
      } else if (nextIndex >= siblings.length) {
        nextIndex = 0;
      }

      return siblings[nextIndex];
    }
  }]);

  return NavA11y;
}();